// extracted by mini-css-extract-plugin
module.exports = {"formFooter":"formFooter--XT6cX"};